// extracted by mini-css-extract-plugin
export default {"nav-button":"XzMRoi","navButton":"XzMRoi","nav-text":"ZMf6Gh","navText":"ZMf6Gh","nav-arrow":"NjbPu8","navArrow":"NjbPu8","disabled":"OlV30R","prev":"KuGKez","next":"zrkS1r"};